import { useState } from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const buyPageStyles = `
  .buy-hero {
    position: relative;
    width: 100%;
    height: 480px;
    background-image: url('/images/buy_hero_bg.png');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
  }
  .buy-hero-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(180deg, rgba(0,46,83,0.85) 0%, rgba(0,46,83,0.4) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
  }
  .buy-hero h1 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 15px;
    letter-spacing: -1px;
    text-shadow: 0 4px 15px rgba(0,0,0,0.3);
  }
  .buy-hero p {
    color: #e0e6ed;
    font-size: 20px;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    max-width: 700px;
  }
  .form-container {
    position: relative;
    max-width: 900px;
    margin: -120px auto 100px auto;
    padding: 60px 70px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 25px 60px rgba(0,46,83,0.1);
    z-index: 10;
  }
  .form-header { text-align: center; margin-bottom: 50px; }
  .form-header h2 { 
    color: #002e53; 
    font-size: 32px; 
    font-weight: 600; 
    margin-bottom: 15px; 
    font-family: 'Poppins', sans-serif; 
  }
  .form-header p { 
    color: #5c6b7a; 
    font-size: 16px; 
    line-height: 1.7; 
    max-width: 600px;
    margin: 0 auto;
  }
  .inquiry-form { display: flex; flex-direction: column; gap: 35px; }
  .form-group { display: flex; flex-direction: column; gap: 8px; position: relative; }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
  .form-group label { 
    color: #7a8b9c; 
    font-weight: 600; 
    font-size: 12px; 
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-family: 'Poppins', sans-serif;
  }
  .form-group input, .form-group select, .form-group textarea {
    padding: 16px 20px;
    border: 1px solid #e2e8f0;
    font-size: 15px;
    font-family: 'Poppins', sans-serif;
    color: #002e53;
    background: #f8fafc;
    transition: all 0.3s ease;
    border-radius: 12px;
  }
  .form-group input::placeholder, .form-group textarea::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
  .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
    outline: none;
    border-color: #C5A059;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(197,160,89,0.1);
  }
  .form-group textarea { resize: vertical; min-height: 120px; }
  .form-group select { cursor: pointer; appearance: none; width: 100%; }
  .select-wrapper { position: relative; width: 100%; display: block; }
  .select-wrapper::after {
    content: '▼';
    font-size: 10px;
    color: #C5A059;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
  .required { color: #C5A059; font-size: 14px; margin-left: 2px; }
  .buy-submit-btn {
    background: #002e53;
    color: #ffffff;
    padding: 20px 40px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.4s ease;
    margin-top: 15px;
    font-family: 'Poppins', sans-serif;
    position: relative;
    overflow: hidden;
  }
  .buy-submit-btn::before {
    content: '';
    position: absolute;
    top: 0; left: -100%;
    width: 100%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: all 0.5s ease;
  }
  .buy-submit-btn:hover { 
    background: #001a30; 
    transform: translateY(-3px); 
    box-shadow: 0 15px 30px rgba(0,46,83,0.2); 
  }
  .buy-submit-btn:hover::before { left: 100%; }
  .success-message { 
    background: rgba(197, 160, 89, 0.08); 
    color: #002e53; 
    padding: 18px 25px; 
    border-radius: 8px; 
    border-left: 4px solid #C5A059; 
    margin-bottom: 40px; 
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
  }
  @media (max-width: 768px) {
    .buy-hero { height: 400px; }
    .buy-hero h1 { font-size: 40px; }
    .buy-hero p { font-size: 16px; padding: 0 20px; }
    .form-container { margin: -80px 20px 60px 20px; padding: 40px 30px; }
    .form-row { grid-template-columns: 1fr; gap: 30px; }
  }
`

const initialForm = {
  firstName: '', lastName: '', email: '', phone: '',
  propertyType: '', budget: '', location: '', bedrooms: '', message: '',
}

function BuyPage() {
  const [form, setForm] = useState(initialForm)
  const [success, setSuccess] = useState(false)

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await fetch('/api/admin/buy-inquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form })
      })
      if (!res.ok) throw new Error('Submission failed')
      setSuccess(true)
      setForm(initialForm)
      setTimeout(() => setSuccess(false), 5000)
    } catch (err) {
      alert('Failed to send inquiry. Please try again.')
    }
  }

  return (
    <div className="website-wrapper wide" id="all_wrapper">
      <div className="container-fluid px-0 wpresidence_main_wrapper_class wide">
        <style>{buyPageStyles}</style>
        <Navbar />

        <div className="buy-hero">
          <div className="buy-hero-overlay">
            <h1>Buy Your Dream Property</h1>
            <p>Exclusive access to Dubai's most prestigious properties. Let our expert team guide you home.</p>
          </div>
        </div>

        <div className="form-container">
          <div className="form-header">
            <h2>Your Property Inquiry</h2>
            <p>Provide your details below and our luxury property specialists will tailor a personalized portfolio just for you.</p>
          </div>

          {success && (
            <div className="success-message">
              Thank you for your inquiry. A dedicated luxury specialist will contact you shortly.
            </div>
          )}

          <form className="inquiry-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name <span className="required">*</span></label>
                <input type="text" id="firstName" name="firstName" required
                  placeholder="Enter your first name" value={form.firstName} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name <span className="required">*</span></label>
                <input type="text" id="lastName" name="lastName" required
                  placeholder="Enter your last name" value={form.lastName} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email Address <span className="required">*</span></label>
                <input type="email" id="email" name="email" required
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                  title="Please enter a valid email address (e.g., name@example.com)"
                  placeholder="your.email@example.com" value={form.email} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number <span className="required">*</span></label>
                <input type="tel" id="phone" name="phone" required
                  placeholder="+1 (555) 000-0000" value={form.phone} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="propertyType">Property Type <span className="required">*</span></label>
                <div className="select-wrapper">
                  <select id="propertyType" name="propertyType" required value={form.propertyType} onChange={handleChange}>
                    <option value="" disabled hidden>Select property type</option>
                    <option value="apartment">Apartment</option>
                    <option value="villa">Villa</option>
                    <option value="townhouse">Townhouse</option>
                    <option value="penthouse">Penthouse</option>
                    <option value="studio">Studio</option>
                    <option value="land">Land</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="budget">Budget Range <span className="required">*</span></label>
                <div className="select-wrapper">
                  <select id="budget" name="budget" required value={form.budget} onChange={handleChange}>
                    <option value="" disabled hidden>Select budget range</option>
                    <option value="under-500k">Under $500,000</option>
                    <option value="500k-1m">$500,000 - $1,000,000</option>
                    <option value="1m-2m">$1,000,000 - $2,000,000</option>
                    <option value="2m-5m">$2,000,000 - $5,000,000</option>
                    <option value="above-5m">Above $5,000,000</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="location">Preferred Location</label>
              <input type="text" id="location" name="location"
                placeholder="e.g., Dubai Marina, Downtown Dubai" value={form.location} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="bedrooms">Number of Bedrooms</label>
              <div className="select-wrapper">
                <select id="bedrooms" name="bedrooms" value={form.bedrooms} onChange={handleChange}>
                  <option value="" disabled hidden>Select bedrooms</option>
                  <option value="studio">Studio</option>
                  <option value="1">1 Bedroom</option>
                  <option value="2">2 Bedrooms</option>
                  <option value="3">3 Bedrooms</option>
                  <option value="4">4 Bedrooms</option>
                  <option value="5+">5+ Bedrooms</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="message">Additional Requirements</label>
              <textarea id="message" name="message"
                placeholder="Tell us more about your requirements, preferred amenities, move-in timeline, etc."
                value={form.message} onChange={handleChange}></textarea>
            </div>
            <button type="submit" className="buy-submit-btn">Submit Inquiry</button>
          </form>
        </div>

        <Footer />
      </div>
    </div>
  )
}

export default BuyPage
